import { Button, Paper, Box, Typography, Theme } from '@mui/material';
import React from 'react';
import { useStyles } from '../../styles';
// import { makeStyles } from '@mui/styles';
// import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import { FilterCells } from '../../globalComponent/AppFilter';
import { AppFilterFields } from '../../utils/interfaces';
// import NoData from '../../globalComponent/NoData';
// import Image from '../../utils/assetHelper';
// import EventsEmptyImg from '../../../../Assets/emptyEventsImg.svg';
import KenColors from '../../../../Helpers/Themes/kenColors';
import Image from '../../../../Assets/application_notFound.png';

const NoEvents: React.FunctionComponent<{ filterData: AppFilterFields; handleFilerRemove: (key: string) => void; handleFilterOpen: () => void }> = (props) => {
  const classes = useStyles();
  const { filterData, handleFilerRemove, handleFilterOpen } = props;

  return (
    <Paper className={`scrollbar-cusgray ${classes.cardContainer}`} style={{ overflow: 'hidden', display: 'block' }}>
      <div className="filter-cells-container">
        {Object.keys(filterData).length > 0 && (
          <div className={classes.cellsContainer}>
            <FilterCells
              cellsArray={filterData}
              handleFilerRemove={(key) => {
                handleFilerRemove(key);
              }}
            />
          </div>
        )}
        
      </div>
      <Paper className={classes.noEvent}>
        <img className={classes.noEventImage} src={Image} alt="noevents" />
        <Typography color={KenColors.ClientBlack2} fontWeight={'500'} fontSize={'16px'}>
          No upcoming events. Stay tuned for more.
        </Typography>
      </Paper>
      {/* <NoData img={EventsEmptyImg} subTitle="Try with another set of filters." title="No upcoming events. Stay tuned for more." /> */}
    </Paper>
  );
};

export default NoEvents;
